import { useFormContext } from "react-hook-form";
import { ErrorMessage, PasswordInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { AddClientFormData } from "../types";

export const ConfirmPasswordField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<AddClientFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">Confirm Password</Typography>
      <PasswordInput
        className="w-full"
        hasError={!!errors.confirmPassword}
        placeholder="Enter password"
        autoComplete="new-password"
        maxLength={65}
        {...register("confirmPassword")}
      />
      <ErrorMessage errors={errors} name="confirmPassword" />
    </div>
  );
};
